var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import MeetingRequestPage from './components/MeetingRequestPage';
/**
 * Main application component for the GenomAI Meeting Request Microservice
 *
 * This is a standalone microservice that can be:
 * 1. Hosted independently at genomai-web-requestform.web.app
 * 2. Embedded in the main GenomAI website via iframe
 * 3. Imported as a component (if published as npm package)
 */
function App() {
    return (_jsx("div", __assign({ className: "App" }, { children: _jsx(MeetingRequestPage, {}) })));
}
export default App;
